import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/components/Landing";
import Quiz from "@/components/Quiz";
import Results from "@/components/Results";
import Compare from "@/components/Compare";
import Share from "@/components/Share";
import Install from "@/components/Install";
import Admin from "@/components/Admin";
import { Header } from "@/components/Header";
import { DEFAULT_ANSWERS } from "@/lib/quizConfig";
import { useIsEmbedded, useEmbedResize, useThemeSync } from "@/lib/embed";

function Shell() {
  const navigate = useNavigate();
  const [answers, setAnswers] = useState({ ...DEFAULT_ANSWERS });
  const [results, setResults] = useState([]);
  const [cart, setCart] = useState([]);

  const embedded = useIsEmbedded();
  useEmbedResize(embedded);
  useThemeSync();

  const addToCart = (item) => {
    setCart((c) => {
      if (c.find((x) => x.variant_id === item.variant_id)) return c;
      return [...c, item];
    });
  };
  const removeFromCart = (idx) => setCart((c) => c.filter((_, i) => i !== idx));

  const resetQuiz = () => {
    setAnswers({ ...DEFAULT_ANSWERS });
    setResults([]);
    navigate("/quiz");
  };

  return (
    <div className={`cd-shell ${embedded ? "cd-embed" : ""}`} data-embed={embedded ? "true" : "false"}>
      {!embedded && (
        <Header showRestart={results.length > 0} onRestart={resetQuiz} />
      )}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/quiz" element={<Quiz setResults={setResults} setAnswers={setAnswers} />} />
        <Route
          path="/results"
          element={
            <Results
              results={results}
              answers={answers}
              resetQuiz={resetQuiz}
              cart={cart}
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              embedded={embedded}
            />
          }
        />
        <Route path="/compare" element={<Compare />} />
        <Route path="/share/:id" element={<Share addToCart={addToCart} />} />
        <Route path="/install" element={<Install />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            border: "1px solid var(--cd-border)",
            fontFamily: "Inter, system-ui, sans-serif",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
